export default __webpack_public_path__ + "static/media/storageUnit1-afterA-2048w.d32edfc1.webp";